var map = {
	"./de/cv-play.png": "mlsU",
	"./en/cv-play.png": "8ZgW",
	"./es/cv-play.png": "uCjh",
	"./fr/cv-play.png": "M45x",
	"./ja/cv-play.png": "4P/Y",
	"./ko/cv-play.png": "VIL+",
	"./pt/cv-play.png": "jWou",
	"./ru/cv-play.png": "/ydy",
	"./tc/cv-play.png": "yLuk",
	"./th/cv-play.png": "HoEt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Cy6g";